import React, { useRef, useState, useEffect, useCallback, useMemo, useImperativeHandle } from 'react';
import lodashGet from 'lodash/get';
import { isObject } from 'lodash';
import { Spin, Tooltip, Form, Affix } from 'antd';
import Button from '@lingxi-common-component/sirius-ui/Button';
import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
import debounce from 'lodash/debounce';
import { apiHolder as api, apis, getFolderStartContactId, MAX_SUB_ACCOUNT_COUNT, } from 'api';
import { useActions, useAppDispatch, MailActions, useAppSelector } from '@web-common/state/createStore';
import NetWatcher from '@web-common/components/UI/NetWatcher';
import { Thunks } from '@web-common/state/reducer/mailReducer';
import useMsgCallback from '@web-common/hooks/useMsgCallback';
import Message from '@web-common/components/UI/Message/SiriusMessage';
import { TongyongShuru } from '@sirius/icons';
import { actions as mailTabActions, tabId, tabType } from '@web-common/state/reducer/mailTabReducer';
import MultAccountsLoginModal from '@web-common/components/UI/MultAccountsLoginModal/index';
import Loadable from '@loadable/component';
const AdvancedSearchForm = Loadable(() => import('../AdvancedSearchForm/AdvancedSearchForm'));
import useState2RM from '../../hooks/useState2ReduxMock';
import BaseSearchFilter from '../BaseSearchFilter';
import SearchResult from './SearchResult';
import { FLOLDER, MAIL_SEARCH_FILTER } from '../../common/constant';
const PersonalMarkModalProps = Loadable(() => import('@web-common/components/UI/SiriusContact/personalMark/modal'));
import { folderId2Number, buildSearchString, getFolderNameById, folderIdIsContact, promiseIsTimeOut } from '../../util';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
import MailSubTab from './MailSubTab';
import AllFolderContainer from './AllFoldder/AllFolderContainer';
import styles from './ColumnMailBox.module.scss';
import EmlUploader from './EmlUploader';
import SearchBox from './SearchBox';
import MailFolders from './MailFolders';
import { getIn18Text } from 'api';
import { AddSmallIcon, AddTagIcon } from '@web-mail/components/MailTagList/Icon';
import { eventApi } from '@web-contact/_mock_';
import { removeAllMiniDrawer, Module } from '@lxunit/app-l2c-crm';
import HollowOutGuide from '@web-common/components/UI/HollowOutGuideNew/hollowOutGuide';
import AddAccountBanner from '@web/images/icons/mail/addAccountBanner.png';
import CloseIcon from '@web-common/components/UI/Icons/svgs/CloseMailSvg';
import useMsgRenderCallback from '@web-common/hooks/useMsgRenderCallback';
import { useGetOrgInfo } from '@web-common/hooks/useGetOrgInfo';
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const systemApi = api.api.getSystemApi();
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const storeApi = api.api.getDataStoreApi();
const ColumnMailBox = (props, ref) => {
    var _a, _b;
    const [inputValue, setInputValue] = useState(undefined);
    const dispatch = useAppDispatch();
    const reducer = useActions(MailActions);
    useGetOrgInfo();
    const orgInfo = useAppSelector(state => state.loginReducer.orgInfo);
    const [mailSearching, doUpdateMailSearching] = useState2RM('mailSearching', 'doUpdateMailSearching');
    const [mailSearchStateMap, doUpdateMailSearchStateMap] = useState2RM('mailSearchStateMap', 'doUpdateMailSearchStateMap');
    const [, setMailSearchMoreAccounts] = useState2RM('mailSearchMoreAccounts', 'doUpdateMailSearchMoreAccounts');
    const isSearching = useMemo(() => !!mailSearching, [mailSearching]);
    const isAdvancedSearch = useMemo(() => mailSearching === 'advanced', [mailSearching]);
    const [searchType, setSearchType] = useState2RM('mailSearchType', 'doUpdateMailSearchType');
    const [, setMailSearchRecord] = useState2RM('', 'doUpdateMailSearchRecord');
    const [searchLoading, setSearchLoading] = useState2RM('searchLoading', 'doUpdateMailSearchLoading');
    const [, setListLoading] = useState2RM('', 'doUpdateMailListLoading');
    const [selectedSearchKeys, setSelectedSearchKeys] = useState2RM('selectedSearchKeys', 'doUpdateSelectedSearchKey');
    const [selectedKeys, setSelectedKeys] = useState2RM('selectedKeys', 'doUpdateSelectedKey');
    const [refreshBtnLoading, setRefreshBtnLoading] = useState2RM('refreshBtnLoading', 'doUpdateRefershBtnLoading');
    const currentTabType = useAppSelector(state => state.mailTabReducer.currentTab.type);
    const [advancedSearchVisible, setAdvancedSearchVisible] = useState2RM('advancedSearchVisible', 'doUpdateAdvancedSearchVisible');
    const [expandedSearchKeys, setExpandedSearchKeys] = useState2RM('expandedSearchKeys', 'doUpdateExpandedSearchKeys');
    const [mailTreeStateMap, setTreeState] = useState2RM('mailTreeStateMap', 'doUpdateMailTreeState');
    const [addContactModelVisiable, setAddContactModelVisiable] = useState2RM('addContactModelVisiable');
    const [advancedSearchLoading, setAdvancedSearchLoading] = useState2RM('advancedSearchLoading', 'doUpdateAdvancedSearchLoading');
    const [, setSearchMail] = useState2RM('', 'doUpdateActiveSearchMailId');
    const [mailSearchAccount, doUpdateMailSearchAccount] = useState2RM('mailSearchAccount', 'doUpdateMailSearchAccount');
    const [advanceSearchFromValues, setAdvanceSearchFromValues] = useState2RM('advanceSearchFromValues', 'doUpdateAdvanceSearchFromValues');
    const [useRealList, _] = useState2RM('useRealList', 'doUpdateUseRealList');
    const [showBanner, setShowBanner] = useState(false);
    const { productVersionInfo: { navigateVersion }, } = useGetProductAuth();
    const [otherClusterNode] = useState2RM('otherClusterNode');
    const accountCount = useAppSelector(state => {
        var _a;
        let count = 0;
        try {
            const map = state.mailReducer.mailTreeStateMap;
            for (let i in map) {
                if (map[i] && !((_a = map[i]) === null || _a === void 0 ? void 0 : _a.expired)) {
                    count++;
                }
            }
        }
        catch (e) {
            console.error(e);
        }
        return count;
    });
    const isMultiAccount = useMemo(() => accountCount && accountCount > 0, [accountCount]);
    const hasMoreAccount = useAppSelector(state => {
        var _a;
        try {
            const map = state.mailReducer.mailTreeStateMap;
            let count = 0;
            for (let i in map) {
                if (map[i] && !((_a = map[i]) === null || _a === void 0 ? void 0 : _a.expired)) {
                    count++;
                }
            }
            return count > 1;
        }
        catch (e) {
            console.error(e);
        }
        return false;
    });
    const referenceElement = useRef();
    const [initStepData, setInitStepData] = useState();
    const [btnWriteMailLoading, setBtnWriteMailLoading] = useState(false);
    const [advancedSearchForm] = Form.useForm();
    const btnWriteMailLoadingTimer = useRef(null);
    const [addAccountVisible, setAddAccountVisible] = useState(false);
    const [totalAccount, setTotalAccount] = useState([]);
    const [subAccountCount, setSubAccountCount] = useState(0);
    const curTabIsReadTab = useMemo(() => currentTabType === tabType.read, [currentTabType]);
    const isCorpMail = useAppSelector(state => state.loginReducer.loginInfo.isCorpMailMode);
    const uploadFileRef = useRef(null);
    const switchDefaultTab = useCallback(() => {
        dispatch(mailTabActions.doChangeCurrentTab('-1'));
    }, []);
    useEffect(() => {
        if (isSearching) {
            setSearchMail({
                id: '',
                accountId: '',
            });
        }
    }, [mailSearchAccount, isSearching]);
    useEffect(() => {
        if (process.env.BUILD_ISEDM || navigateVersion) {
            removeAllMiniDrawer(Module.Email);
        }
    }, [selectedKeys.id, selectedKeys.accountId, isSearching, selectedSearchKeys, navigateVersion]);
    useMsgCallback('writePageDataExchange', e => {
        const { eventStrData } = e;
        if (eventStrData && ['writePageWindowCreated', 'writeTabCreated'].includes(eventStrData)) {
            setBtnWriteMailLoading(false);
            if (btnWriteMailLoadingTimer.current) {
                clearTimeout(btnWriteMailLoadingTimer.current);
                btnWriteMailLoadingTimer.current = null;
            }
        }
    });
    useEffect(() => {
        getTotalAccountList();
        const subAccountEvents = ['SubAccountAdded', 'SubAccountDeleted'];
        const eids = [];
        subAccountEvents.forEach(evName => {
            eids.push(eventApi.registerSysEventObserver(evName, {
                name: 'columnMailBox-' + evName,
                func: () => {
                    setTimeout(() => {
                        getTotalAccountList();
                    }, 10);
                },
            }));
        });
        return () => {
            if (eids && eids.length) {
                eids.forEach((eid, inx) => eventApi.unregisterSysEventObserver(subAccountEvents[inx], eid));
            }
        };
    }, []);
    useEffect(() => {
        accountApi.getMainAndSubAccounts({ expired: false }).then(accounts => {
            setMailSearchMoreAccounts(accounts && accounts.length > 1);
        });
    }, []);
    const getTotalAccountList = async () => {
        const totalAccounts = ((await accountApi.getMainAndSubAccounts({ expired: false })) || []).map(item => ({
            key: item.id,
            value: item.agentEmail,
        }));
        setTotalAccount(totalAccounts);
        updateAllTotalSubAccount();
    };
    const updateAllTotalSubAccount = async () => {
        const subAccounts = (await accountApi.getAllSubAccounts()) || [];
        setSubAccountCount(subAccounts.length);
    };
    const onSearchMail = useCallback(debounce((value, account) => {
        const sType = mailSearchStateMap[account] || (useRealList ? 'server' : 'local');
        if (!useRealList) {
            reducer.onSearchMailUpdateTreeStateMap({ account, value });
        }
        else {
            reducer.beforeSearchServer({ account, value, useRealList });
        }
        dispatch(Thunks.searchMail(Object.assign({ value }, (sType === 'local' ? { extraCloud: true } : null))));
        trackApi.track('pcMail_executeMailSearch', {
            searchMode: `全文搜索（${sType === 'local' ? '本地' : '云端'}）`,
        });
    }, 500), [totalAccount, mailSearchStateMap]);
    const onSearchChange = useCallback(debounce((value, account, showLoading = true) => {
        var _a;
        switchDefaultTab();
        if (!value) {
            reducer.reseOnSearchChange({});
            advancedSearchForm.resetFields();
            reducer.doResetMailSearch({});
        }
        else {
            !account && setSearchLoading(showLoading);
            setListLoading(true);
            const userInfo = systemApi.getCurrentUser();
            const mainAccount = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) || '';
            onSearchMail(value, account || ((_a = totalAccount[0]) === null || _a === void 0 ? void 0 : _a.value) || mainAccount);
        }
    }, 500), [onSearchMail]);
    const reSearch = useCallback((value, account) => {
        if (isAdvancedSearch) {
            handleAdvancedSearch(advanceSearchFromValues);
        }
        else {
            onSearchChange(value, account, false);
        }
        trackApi.track('pcMail_select_leftOptions_mailSearchResultPage', {
            filtratesName: '重置按钮',
        });
    }, [isAdvancedSearch, advanceSearchFromValues]);
    const onSeverSearch = useCallback((account) => {
        reducer.beforeSearchServer({ account });
        dispatch(Thunks.loadSearchMailList({
            startIndex: 0,
            noCache: false,
        }));
        trackApi.track('pcMail_executeMailSearch', {
            searchMode: '全文搜索（云端）',
        });
    }, []);
    const onSeverSearchMoreAccounts = useCallback(() => {
        setListLoading(true);
        dispatch(Thunks.loadSearchMailList({
            startIndex: 0,
            noCache: false,
        }));
    }, []);
    const refreshPageCb = useCallback(refreshHasNewMail => {
        if (curTabIsReadTab && !isSearching) {
            if (refreshHasNewMail) {
                setTimeout(() => {
                    Message.success({
                        content: (React.createElement("span", null,
                            getIn18Text('SHOUXINCHENGGONG\uFF0C11'),
                            React.createElement("span", { onClick: switchDefaultTab, style: { color: '#386ee7', marginLeft: '24px', cursor: 'pointer' } }, getIn18Text('QUCHAKAN')))),
                    });
                }, 0);
            }
            else {
                setTimeout(() => {
                    Message.success({
                        content: getIn18Text('SHOUXINCHENGGONG\uFF0C'),
                    });
                });
            }
        }
        else {
            setTimeout(() => {
                Message.success({
                    content: getIn18Text('SHOUXINCHENGGONG'),
                });
            }, 0);
        }
    }, [curTabIsReadTab, isSearching, switchDefaultTab]);
    const [realListPageSize, setRealListCurrentPage] = useState2RM('realListCurrentPage', 'doUpdateRealListPage');
    const handleAdvancedSearch = useCallback(async (values) => {
        var _a;
        switchDefaultTab();
        await getTotalAccountList();
        const userInfo = systemApi.getCurrentUser();
        const mainAccount = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) || '';
        const account = ((_a = totalAccount.find(item => item.value === (values === null || values === void 0 ? void 0 : values.account))) === null || _a === void 0 ? void 0 : _a.value) || mainAccount;
        const mapKey = !account || account === mainAccount ? 'main' : account;
        const treeList = mailTreeStateMap[mapKey].mailFolderTreeList;
        const newInput = buildSearchString(Object.assign(Object.assign({}, values), { fids: values.fids && values.fids !== '_ALL_FOLDER_' ? getFolderNameById(values.fids, treeList) : undefined }));
        setInputValue(newInput);
        setAdvanceSearchFromValues(values);
        setSearchMail({
            id: '',
            accountId: '',
        });
        doUpdateMailSearchAccount(account);
        doUpdateMailSearchStateMap({
            [account]: 'advanced',
        });
        doUpdateMailSearching('advanced');
        setSearchLoading(false);
        setListLoading(true);
        setAdvancedSearchVisible(false);
        setSelectedSearchKeys({});
        setRealListCurrentPage({ page: 1 });
        dispatch(Thunks.loadAdvanceSearchMailList({
            startIndex: 0,
            noCache: true,
        }));
        trackApi.track('pcMail_executeMailSearch', {
            searchMode: '高级搜索（云端）',
        });
    }, [totalAccount, mailTreeStateMap, advancedSearchForm]);
    const handleSwitchFolder = useCallback(debounce((node) => {
        var _a, _b, _c;
        if (node) {
            let key = ((_a = selectedSearchKeys[mailSearchAccount]) === null || _a === void 0 ? void 0 : _a.folder) || FLOLDER.SEARCH_ALL_RESULT;
            console.log('[FolderTree] 选择文件夹 handleSwitchFolder:', key, Date.now());
            const account = (node === null || node === void 0 ? void 0 : node._account) || mailSearchAccount;
            if (node.entry) {
                const { mailBoxId, mailBoxName } = node.entry;
                key = mailBoxId;
                const folderName = mailBoxName;
                if (isSearching) {
                    trackApi.track('pcMail_select_leftOptions_mailSearchResultPage', {
                        filtratesName: '文件夹筛选',
                    });
                }
                else {
                    if (key != FLOLDER.OTHERS && key != FLOLDER.TAG && key != FLOLDER.STAR) {
                        try {
                            const isContant = folderIdIsContact(key);
                            let trackFolderName = folderName;
                            let trackFolderKey = key;
                            if (isContant) {
                                trackFolderKey = FLOLDER.STAR;
                                trackFolderName = getIn18Text('markContact');
                            }
                            else {
                                if (key >= 100) {
                                    trackFolderName = getIn18Text('ZIDINGYIWENJIAN');
                                }
                            }
                            accountApi.getMainAndSubAccounts({ expired: false }).then(accounts => {
                                trackApi.track('pcMail_switch_folder_folderList', {
                                    folderType: trackFolderKey,
                                    folderTypeName: trackFolderName,
                                    agentNumber: accounts && accounts.length > 1 ? accounts.length - 1 : 0,
                                });
                            });
                        }
                        catch (err) {
                            console.error(err);
                        }
                    }
                }
            }
            reducer.doSwitchFolder({
                id: key,
                accountId: account,
                authAccountType: node === null || node === void 0 ? void 0 : node.authAccountType,
            });
            if (isSearching) {
                if (!(node === null || node === void 0 ? void 0 : node.entry)) {
                    let filterKey = '';
                    if (isObject((_b = node === null || node === void 0 ? void 0 : node.filterCond) === null || _b === void 0 ? void 0 : _b.operand)) {
                        filterKey = Object.keys(node.filterCond.operand)[0];
                    }
                    else {
                        filterKey = (_c = node === null || node === void 0 ? void 0 : node.filterCond) === null || _c === void 0 ? void 0 : _c.field;
                    }
                    trackApi.track('pcMail_select_leftOptions_mailSearchResultPage', {
                        filtratesName: MAIL_SEARCH_FILTER[filterKey],
                    });
                }
                if ((node === null || node === void 0 ? void 0 : node.entry) && lodashGet(node, 'children.length', 0) > 0) {
                    const parentCount = lodashGet(node, 'entry.mailBoxUnread', 0);
                    const childrenCount = (node.children || []).reduce((prev, cur) => prev + lodashGet(cur, 'entry.mailBoxUnread', 0), 0);
                    if (parentCount === childrenCount && (node === null || node === void 0 ? void 0 : node.mailBoxId) && !expandedSearchKeys.includes(node.mailBoxId)) {
                        const expandList = [...expandedSearchKeys];
                        expandList.push(node.mailBoxId);
                        expandFolder(expandList);
                    }
                }
                dispatch(Thunks.refreshMailList({ showLoading: false }));
                const sType = mailSearchStateMap[account] || 'local';
                trackApi.track('pcMail_executeMailSearch', {
                    searchMode: `全文搜索（${sType === 'local' ? '本地' : '云端'}）`,
                });
            }
        }
    }, 300, {
        leading: true,
        trailing: true,
    }), [isSearching, expandedSearchKeys, mailSearchStateMap]);
    const expandFolder = useCallback((keys, accountId) => {
        const numberKeys = folderId2Number(keys);
        setTreeState({
            accountId,
            name: 'expandedKeys',
            value: numberKeys,
        });
    }, []);
    const expandSearchFolder = (keys, accountId) => {
        const numberKeys = folderId2Number(keys);
        setExpandedSearchKeys(numberKeys);
    };
    useImperativeHandle(ref, () => ({
        changeInputValue: (v) => {
            setInputValue(v);
        },
    }));
    const handleWriteBtnClick = useCallback(debounce(() => {
        mailApi.callWriteLetterFunc({
            contact: [],
            writeType: 'common',
            mailType: 'common',
            mailFormClickWriteMail: selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.accountId,
        });
        trackApi.track('pcMail_click_writeMailButton_topBar', { source: 'Inbox' });
        setBtnWriteMailLoading(true);
        if (!btnWriteMailLoadingTimer.current) {
            btnWriteMailLoadingTimer.current = setTimeout(() => {
                setBtnWriteMailLoading(false);
                btnWriteMailLoadingTimer.current = null;
            }, 1500);
        }
    }, 200), [selectedKeys]);
    const onSearchTypeChange = useCallback((type, toRecord) => {
        setSearchMail({
            id: '',
            accountId: '',
        });
        setSearchType(type);
        setMailSearchRecord(toRecord);
    }, [setSearchMail, setSearchType, setMailSearchRecord]);
    const MailFoldersElement = useMemo(() => {
        return React.createElement(MailFolders, { className: `${process.env.BUILD_ISEDM || navigateVersion ? 'wm-show-folder-line' : ''}`, uploadFileRef: uploadFileRef });
    }, [navigateVersion]);
    const addAccountCloseModel = useCallback(refresh => {
        setAddAccountVisible(false);
    }, []);
    const onAddAccount = useCallback((params) => {
        const { trackName } = params || {};
        if (trackName)
            trackApi.track(trackName, { action: 'add' });
        if (subAccountCount >= MAX_SUB_ACCOUNT_COUNT) {
            Message.warn({
                content: getIn18Text('accountMaxTip'),
            });
        }
        else {
            setAddAccountVisible(true);
        }
    }, [subAccountCount]);
    const isShareadAccount = ((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.isSharedAccount) || false;
    useEffect(() => {
        var _a;
        if (!((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.isSharedAccount)) {
            trackApi.track('pc_mail_addEmail_topButton', { view: true });
        }
    }, []);
    const AddAccountElement = useMemo(() => {
        const isMuiti = accountCount > 1;
        return (React.createElement("div", { className: styles.folderTitleWrap },
            React.createElement("p", { className: "m-add-account" },
                React.createElement("span", { style: { fontSize: '12px', flex: '1 1 auto' } }, getIn18Text('YOUXIANG')),
                !isShareadAccount && !(orgInfo === null || orgInfo === void 0 ? void 0 : orgInfo.sirius_add_other_mail_hidden) ? (React.createElement(Tooltip, { title: getIn18Text('TIANJIAYOUXIANGZHANG'), trigger: ['hover'] },
                    React.createElement("span", { "data-test-id": "mail-add-account-btn", hidden: isSearching, className: `title-add-btn dark-invert ${isMuiti ? 'multi' : 'single'}`, onClick: () => onAddAccount({ trackName: 'pc_mail_addEmail_topButton' }) }, isMuiti ? React.createElement(AddTagIcon, null) : React.createElement(AddSmallIcon, null)))) : null),
            React.createElement(MultAccountsLoginModal, { visible: addAccountVisible, closeModel: addAccountCloseModel, loginInfo: { type: 'bind', way: 'mailList' }, initStepData: initStepData, setInitStepData: setInitStepData })));
    }, [accountCount, isSearching, addAccountVisible, onAddAccount, addAccountCloseModel, isShareadAccount, orgInfo === null || orgInfo === void 0 ? void 0 : orgInfo.sirius_add_other_mail_hidden]);
    const activeAddedStarContact = useCallback((list) => {
        var _a;
        try {
            const key = ((_a = mailTreeStateMap === null || mailTreeStateMap === void 0 ? void 0 : mailTreeStateMap.main) === null || _a === void 0 ? void 0 : _a.expandedKeys) || [];
            const treeExpandKeys = [...new Set([...key, FLOLDER.STAR])];
            setTreeState({
                name: 'expandedKeys',
                value: treeExpandKeys,
            });
            if (list && list.length) {
                const { type, id } = list[0] || {};
                if (type && id) {
                    const key = getFolderStartContactId(id, type);
                    setSelectedKeys({
                        id: key,
                    });
                }
            }
        }
        catch (e) {
            console.error('[error: expandStarContactFolder]', e);
        }
    }, [setSelectedKeys, (_b = mailTreeStateMap === null || mailTreeStateMap === void 0 ? void 0 : mailTreeStateMap.main) === null || _b === void 0 ? void 0 : _b.expandedKeys]);
    const EmlUploaderElement = useMemo(() => {
        return React.createElement(EmlUploader, { ref: uploadFileRef });
    }, []);
    const MailSubTabElement = useMemo(() => {
        return React.createElement(MailSubTab, null);
    }, []);
    const WriteBtnElement = useMemo(() => {
        return (React.createElement(Button, { "data-test-id": "mail-write-mail-btn", btnType: "primary", className: "u-mail-send-btn sirius-no-drag", onClick: handleWriteBtnClick, loading: btnWriteMailLoading },
            !btnWriteMailLoading ? (React.createElement("span", { className: "icon" },
                React.createElement(TongyongShuru, null))) : (React.createElement(React.Fragment, null)),
            React.createElement("span", { className: "text" }, getIn18Text('XIEYOUJIAN'))));
    }, [handleWriteBtnClick, btnWriteMailLoading]);
    const RefreshBtn = useMemo(() => {
        return (React.createElement(Tooltip, { placement: "bottom", title: getIn18Text('SHOUXIN'), mouseEnterDelay: 0.3, mouseLeaveDelay: 0.15 },
            React.createElement("div", { "data-test-id": "mail-refresh-btn", className: `u-refresh sirius-no-drag btn ${refreshBtnLoading ? 'sirius-spin' : ''}`, onClick: () => {
                    trackApi.track('pcMail_click_receivingMailButton_topBar');
                    promiseIsTimeOut(dispatch(Thunks.refreshPage({
                        successCb: (refreshHasNewMail) => {
                            refreshPageCb(refreshHasNewMail);
                        },
                    })), 'pc_refreshPage_timeout', {
                        from: 'columnMailBox_btn',
                    });
                    if (isSearching) {
                        reSearch(inputValue, mailSearchAccount);
                    }
                    if (process.env.BUILD_ISEDM || navigateVersion) {
                        dispatch(Thunks.refreshPage_cm({
                            sliceId: tabId.readCustomer,
                        }));
                    }
                } })));
    }, [refreshBtnLoading, refreshPageCb, navigateVersion]);
    const SearchBoxElement = useMemo(() => {
        return React.createElement(SearchBox, { ref: referenceElement, inputValue: inputValue, setInputValue: setInputValue, advancedSearchForm: advancedSearchForm, totalAccount: totalAccount });
    }, [totalAccount, inputValue, advancedSearchForm]);
    const closeBanner = (e) => {
        trackApi.track('pc_mail_addEmail_banner', { action: 'close' });
        e.stopPropagation();
        storeApi.putSync('noMoreBanner', 'true');
        setShowBanner(false);
    };
    useEffect(() => {
        const noMoreBanner = storeApi.getSync('noMoreBanner').data;
        if (noMoreBanner === 'true') {
            setShowBanner(false);
        }
        else {
            if (!isMultiAccount) {
                console.log('pc_mail_addEmail_banner');
                trackApi.track('pc_mail_addEmail_banner', { view: true });
                setShowBanner(true);
            }
        }
    }, [isMultiAccount]);
    const BannerElement = useMemo(() => {
        if (orgInfo === null || orgInfo === void 0 ? void 0 : orgInfo.sirius_add_other_mail_hidden) {
            return null;
        }
        return (React.createElement("div", { className: styles.addBannerContainer },
            React.createElement("div", { className: styles.addAccountBanner },
                React.createElement("img", { src: AddAccountBanner }),
                React.createElement("div", { className: styles.contArea, onClick: () => onAddAccount({ trackName: 'pc_mail_addEmail_banner' }) },
                    React.createElement(AddSmallIcon, null),
                    React.createElement("span", { className: styles.addText }, getIn18Text('TIANJIAGONGZYX')),
                    React.createElement("div", { onClick: e => closeBanner(e), className: styles.close },
                        React.createElement(CloseIcon, null))))));
    }, [orgInfo === null || orgInfo === void 0 ? void 0 : orgInfo.sirius_add_other_mail_hidden]);
    const PersonalMarkModalElement = useMemo(() => {
        return (addContactModelVisiable && (React.createElement(PersonalMarkModalProps, { onCancel: () => {
                setAddContactModelVisiable(false);
            }, onSure: list => {
                if (list && list.length) {
                    activeAddedStarContact(list);
                }
                setAddContactModelVisiable(false);
            } })));
    }, [addContactModelVisiable, activeAddedStarContact]);
    const AdvancedSearchFormElement = useMemo(() => {
        return (advancedSearchVisible && (React.createElement(AdvancedSearchForm, { isSearching: isSearching, treeMap: mailTreeStateMap, advancedSearchLoading: advancedSearchLoading, advancedSearchVisible: advancedSearchVisible, referenceElement: referenceElement, onSubmit: handleAdvancedSearch, form: advancedSearchForm, onClose: setAdvancedSearchVisible })));
    }, [advancedSearchVisible, isSearching, mailTreeStateMap, advancedSearchLoading, handleAdvancedSearch, advancedSearchForm, setAdvancedSearchVisible]);
    const doRemoveLoginingSubAccount = (email) => {
        reducer.doRemoveLoginingSubAccount(email);
    };
    const getEmailByEventData = (ev) => {
        if (ev && ev.eventData) {
            const eventData = ev.eventData;
            const email = eventData.email;
            const subAccount = eventData.agentEmail || eventData.subAccount;
            return email || subAccount;
        }
        return '';
    };
    useEffect(() => {
        const startEventName = 'subAccountSyncLoginStart';
        const eventPostfix = '-columnMailBox';
        const startEid = eventApi.registerSysEventObserver(startEventName, {
            name: startEventName + eventPostfix,
            func: ev => {
                if (ev && ev.eventData) {
                    const emailInfos = (ev.eventData || []);
                    reducer.doAddLoginingSubAccount(emailInfos.map(item => item.email));
                }
            },
        });
        const removeEvents = ['subAccountSyncLoginFailed', 'SubAccountDeleted'];
        const removeEventIds = removeEvents.map(eventName => {
            return eventApi.registerSysEventObserver(eventName, {
                name: `${eventName}-columnMailBox`,
                func: ev => {
                    const email = getEmailByEventData(ev);
                    doRemoveLoginingSubAccount(email);
                },
            });
        });
        return () => {
            eventApi.unregisterSysEventObserver(startEventName, startEid);
            removeEventIds.forEach((eventId, inx) => {
                const eventName = removeEvents[inx];
                eventApi.unregisterSysEventObserver(eventName, eventId);
            });
        };
    }, []);
    const treeScroll = useRef(null);
    const showMergeFolder = useMemo(() => {
        return hasMoreAccount && accountCount - ((otherClusterNode === null || otherClusterNode === void 0 ? void 0 : otherClusterNode.length) || 0) > 1;
    }, [accountCount, hasMoreAccount, otherClusterNode]);
    const mainFolderList = useAppSelector(state => { var _a, _b; return ((_b = (_a = state.mailReducer.mailTreeStateMap) === null || _a === void 0 ? void 0 : _a.main) === null || _b === void 0 ? void 0 : _b.mailFolderTreeList) || []; });
    const wmRefreshGuideLock = useRef(false);
    const wmFolderSortGuide = useMemo(() => {
        var _a;
        if (process.env.BUILD_ISEDM || navigateVersion) {
            if ((_a = storeApi.getSync('localFolderSort')) === null || _a === void 0 ? void 0 : _a.data) {
                return false;
            }
            if (mainFolderList &&
                mainFolderList.length > 0 &&
                mainFolderList.find(folder => {
                    var _a, _b;
                    return ((_a = folder === null || folder === void 0 ? void 0 : folder.entry) === null || _a === void 0 ? void 0 : _a.mailBoxId) == FLOLDER.CUSTOMER_UNFOLLOW || ((_b = folder === null || folder === void 0 ? void 0 : folder.entry) === null || _b === void 0 ? void 0 : _b.mailBoxId) == FLOLDER.UNFOLLOW;
                })) {
                return true;
            }
        }
        return false;
    }, [mainFolderList === null || mainFolderList === void 0 ? void 0 : mainFolderList.length, navigateVersion]);
    useEffect(() => {
        if (isMultiAccount && !isSearching)
            trackApi.track('pc_mail_addEmail_bottomButton', { view: true });
    }, [isMultiAccount, isSearching]);
    const FolderContainerElement = useMemo(() => {
        return (React.createElement("div", { className: `overWpra m-tree-container`, style: { display: isSearching ? 'none' : 'block' }, id: "mail-folder-wrap", ref: treeScroll },
            showMergeFolder ? React.createElement(AllFolderContainer, { treeScroll: treeScroll }) : React.createElement(React.Fragment, null),
            React.createElement(Affix, { target: () => treeScroll.current, offsetTop: 0 }, AddAccountElement),
            MailFoldersElement,
            accountCount > 1 && !(orgInfo === null || orgInfo === void 0 ? void 0 : orgInfo.sirius_add_other_mail_hidden) ? (React.createElement("div", { className: styles.addAccountArea, onClick: () => onAddAccount({ trackName: 'pc_mail_addEmail_bottomButton' }) },
                React.createElement("div", { className: styles.cont },
                    React.createElement("div", { className: styles.addBut },
                        React.createElement(AddSmallIcon, null)),
                    getIn18Text('TIANJIAYOUXIANGZHANG')))) : (React.createElement(React.Fragment, null))));
    }, [isSearching, showMergeFolder, AddAccountElement, orgInfo === null || orgInfo === void 0 ? void 0 : orgInfo.sirius_add_other_mail_hidden]);
    const GuideFolderContainerElement = useMemo(() => {
        return process.env.BUILD_ISEDM || navigateVersion ? (React.createElement(HollowOutGuide, { enable: wmFolderSortGuide, title: getIn18Text('YOUXIANGWENJJSJL'), guideId: 'wmGuideSortUserFolder ', intro: getIn18Text('XINZENGYOUDWDDGJWJJW29'), placement: "right", hash: "#mailbox", padding: [6, 0, 6, 0], borderRadius: 0, okText: getIn18Text('setting_system_switch_web'), onClose: () => {
                storeApi.put('localFolderSort', 'true');
                if (!wmRefreshGuideLock.current) {
                    wmRefreshGuideLock.current = true;
                    dispatch(Thunks.wmGuideSortUserFolder({}));
                }
            } }, FolderContainerElement)) : (FolderContainerElement);
    }, [wmFolderSortGuide, FolderContainerElement, navigateVersion]);
    useMsgRenderCallback('toAddAccount', ev => {
        if (subAccountCount >= MAX_SUB_ACCOUNT_COUNT) {
            Message.warn({ content: getIn18Text('accountMaxTip') });
            return;
        }
        const { eventData } = ev;
        if (eventData) {
            const { email, purpose } = eventData;
            if (purpose === 'intoStep2') {
                setInitStepData({ email, purpose });
            }
            if (purpose === 'reBind') {
                setInitStepData({ email, purpose });
            }
        }
        setTimeout(() => setAddAccountVisible(true), 500);
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(NetWatcher, null),
        EmlUploaderElement,
        MailSubTabElement,
        React.createElement("div", { className: "m-edit-container" },
            WriteBtnElement,
            RefreshBtn),
        SearchBoxElement,
        showBanner && BannerElement,
        GuideFolderContainerElement,
        isSearching && (React.createElement("div", { className: "m-tree-container m-tree-container-relative", style: { display: isSearching ? 'block' : 'none' } },
            searchLoading && (React.createElement("div", { className: "u-loading" },
                React.createElement(Spin, { indicator: React.createElement(LoadingOutlined, { style: { fontSize: 24 }, spin: true }) }))),
            React.createElement("div", { className: "m-search-res", style: { display: searchLoading || isAdvancedSearch ? 'none' : 'block' } }, !isCorpMail && (React.createElement(BaseSearchFilter, { searchWord: inputValue || '', searchType: searchType, setSearchType: type => onSearchTypeChange(type, false), onSearchChange: onSearchChange }))),
            isSearching && (React.createElement(SearchResult, { handleSwitchFolder: handleSwitchFolder, expandFolder: expandSearchFolder, reSearch: account => reSearch(inputValue, account), onSeverSearch: onSeverSearch, onSeverSearchMoreAccounts: onSeverSearchMoreAccounts })))),
        AdvancedSearchFormElement,
        PersonalMarkModalElement));
};
export default React.forwardRef(ColumnMailBox);
